import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'qaroni-details-day-check-absence-chip',
  templateUrl: './check-details-day-absence-chip.component.html',
  styleUrl: './check-details-day-absence-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckDetailsDayAbsenceChipComponent {
  readonly name = input.required<string>();
  readonly icon = input.required<string>();
  readonly tooltip = input.required<string>();
  readonly classList = input<string>('bg-primary-80 text-primary-40');
}
